import { PacketValueSerialType } from "../../../enum/PacketValueSerialType";
import Gun from "../../Gun";
import Player from "../../Player";

export default class Railgun extends Gun {
    constructor(player: Player) {
        super(player, {
            damage: 250,
            fireRate: 1,
            magSize: 8,
            reloadTime: 5,
            bulletSpeed: 600,
            mouseTrigger: 0
        });
    }

    onShoot(): void {
        const pos = this.player.transform.position.add(this.player.transform.forward.scale(this.player.size + 4));
        const vel = this.player.velocity.add(this.player.transform.forward.scale(this.player.chargedShot ? this.bulletSpeed * 1.5 : this.bulletSpeed));

        this.player.engine.createBulletForAll(pos, vel, [
            {
                key: "team",
                value: this.player.team || "",
                type: PacketValueSerialType.String
            },
            {
                key: "damage",
                value: this.player.chargedShot ? this.damage * 2 : this.damage,
                type: PacketValueSerialType.UInt
            },
            {
                key: "ownerName",
                value: this.player.name,
                type: PacketValueSerialType.String
            }
        ]);

        if (this.player.chargedShot) this.player.chargedShot = false;
    }

    // Draw(yOffset: number): void {
    //     super.Draw(yOffset);

    //     if (this.player.isOwner) {
    //         this.player.ctx.strokeStyle = '#ffffff30';
    //         this.player.engine.Line(this.player.transform.position, this.player.transform.position.add(this.player.velocity.add(this.player.transform.forward.scale(this.bulletSpeed))));
    //     }
    // }
}